import { Flex, mdBumps, TertiaryButton, Typo } from '@wrisk/ui-components'
import React from 'react'

import { Quote } from '../../../domain'
import { ExcessData } from '../../../hooks/adjustments/policy'
import { useExcesses } from '../../../hooks/excess'
import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'

interface VoluntaryExcessProps {
  quote: Quote
  onChange?: (excess: ExcessData) => void
}

const tKey = TKey('components.voluntary-excess')

export const VoluntaryExcess: React.FC<VoluntaryExcessProps> = ({ quote, onChange }) => {
  const { t } = useWriskTranslation()

  const { voluntary: voluntaryExcesses } = useExcesses(quote)

  return voluntaryExcesses.map(({ voluntaryExcessCode, excess }) => (
    <Flex key={voluntaryExcessCode} variant='raised' columnGap={2} width={1} p={mdBumps}>
      <Flex
        flexDirection='column'
        alignItems='flex-start'
        justifyContent='center'
        rowGap={1}
      >
        <Typo typoSize='xs'>{t(tKey('header'))}</Typo>
        <Typo>{t(tFormats('currency.short'), { amount: excess })}</Typo>
      </Flex>
      {onChange && (
        <TertiaryButton
          layout='small'
          onClick={() =>
            onChange({
              excess,
              excessCode: voluntaryExcessCode,
            })
          }
          data-testid='open-excess-modal'
        >
          {t(tKey('actions.edit'))}
        </TertiaryButton>
      )}
    </Flex>
  ))
}
